/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ideal_Bright_Yak_EndureInputs */

const fr_ideal_bright_yak_endure = /** @type {(inputs: Ideal_Bright_Yak_EndureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarif du produit`)
};

/**

* @param {Ideal_Bright_Yak_EndureInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const ideal_bright_yak_endure = /** @type {((inputs?: Ideal_Bright_Yak_EndureInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ideal_Bright_Yak_EndureInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_ideal_bright_yak_endure(inputs)
});